@for (graph of graphs; track i; let i = $index) {
  <div class="graph-wrapper" [class.graph-wrapper-clickable]="isCacheGraph()">
    <h2 class="graph-title">{{ graph.customTitle }}</h2>
    @if (isCacheGraph()) {
      <div class="graph-hint">
        {{ "analytics.drilldown.hint" | translate }}
      </div>
    }
    <plotly-plot
      class="interactive-plotly-graph"
      [data]="graph.data"
      [layout]="graph.layout"
      [config]="graph.config"
      [id]="'plot-graph-analytic-' + i"
      (plotlyClick)="onBarClick($event, graph, i)"
    ></plotly-plot>
  </div>
}

@if (drilldownGraph) {
  <div class="graph-wrapper graph-wrapper-drilldown">
    <div class="drilldown-header">
      <h2 class="graph-title">{{ drilldownGraph.customTitle }}</h2>
      <button
        class="drilldown-close"
        type="button"
        (click)="closeDrilldown()"
        [attr.aria-label]="'analytics.drilldown.close' | translate"
      >
        <svg-icon [name]="'close'"></svg-icon>
      </button>
    </div>
    <plotly-plot
      [data]="drilldownGraph.data"
      [layout]="drilldownGraph.layout"
      [config]="drilldownGraph.config"
      id="plot-graph-analytic-drilldown"
    ></plotly-plot>
  </div>
}
